import React from 'react';
import { IHistorischeStatistieken } from '../models/page';
import { H6 } from './text';

export interface IZilverenTableProps {
	results: IHistorischeStatistieken;
	defaultOpen?: boolean;
}

export default function ZilverenSchildTable({ results, defaultOpen }: IZilverenTableProps) {
	const schilden = results.zilverenSchilden.schilden;
	return (
		<>
			<div className="bg-white py-12 sm:py-16 mb-4">
				<div className="mx-auto max-w-7xl px-6 lg:px-8">
					{Array.isArray(schilden) &&
						schilden.map((schild, index) => (
							<div key={index} className="mb-12">
								<div className="mx-auto max-w-4xl lg:mx-0">
									<h2 className="text-3xl font-bold tracking-tight sm:text-4xl">
										{schild.seizoensTitel}
									</h2>
								</div>
								{schild.seizoen?.map((seizoen, schildIndex) => (
									<div key={schildIndex} className="mb-12">
										<ul
											role="list"
											className="mx-auto mt-4 grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 sm:grid-cols-2 lg:mx-0 lg:max-w-none lg:grid-cols-3"
										>
											{seizoen.periode?.map((team, teamIndex) => (
												<li key={teamIndex}>
													<img
														className="aspect-[1/1] w-full rounded-2xl object-cover"
														src={team.img?.sourceUrl}
														alt={team.img?.altText}
													/>

													<H6 className="mt-4">{team.club}</H6>
												</li>
											))}
										</ul>
									</div>
								))}
							</div>
						))}
				</div>
			</div>
		</>
	);
}
